import { render } from "./ProjectDetail.vue?vue&type=template&id=eb049f50&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"

import "./ProjectDetail.vue?vue&type=style&index=0&id=eb049f50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb049f50"]])

export default __exports__